/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePlanTaskDependencyRequest
 */
export interface UpdatePlanTaskDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanTaskDependencyRequest
     */
    dependencyType?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePlanTaskDependencyRequest
     */
    lagDays?: number;
}

/**
 * Check if a given object implements the UpdatePlanTaskDependencyRequest interface.
 */
export function instanceOfUpdatePlanTaskDependencyRequest(value: object): value is UpdatePlanTaskDependencyRequest {
    return true;
}

export function UpdatePlanTaskDependencyRequestFromJSON(json: any): UpdatePlanTaskDependencyRequest {
    return UpdatePlanTaskDependencyRequestFromJSONTyped(json, false);
}

export function UpdatePlanTaskDependencyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePlanTaskDependencyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dependencyType': json['dependencyType'] == null ? undefined : json['dependencyType'],
        'lagDays': json['lagDays'] == null ? undefined : json['lagDays'],
    };
}

export function UpdatePlanTaskDependencyRequestToJSON(json: any): UpdatePlanTaskDependencyRequest {
    return UpdatePlanTaskDependencyRequestToJSONTyped(json, false);
}

export function UpdatePlanTaskDependencyRequestToJSONTyped(value?: UpdatePlanTaskDependencyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dependencyType': value['dependencyType'],
        'lagDays': value['lagDays'],
    };
}

